import { type QueryHookOptions, useQuery } from "@apollo/client";
import { SupportRequestQuery } from "../graphql/queries";
import type {
  SupportRequestQueryType,
  SupportRequestQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useSupportRequestQuery = (
  options?: QueryHookOptions<
    SupportRequestQueryType,
    SupportRequestQueryVariablesType
  >
) => {
  return useQuery<SupportRequestQueryType, SupportRequestQueryVariablesType>(
    SupportRequestQuery,
    options
  );
};
